import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { FSC_TIER_NAMES } from './fscTierNames';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function FscSeatLimitBanner({
  maxQuantity,
  currentTier,
  upgrade
}) {
  const currentTierName = FSC_TIER_NAMES[currentTier];
  return /*#__PURE__*/_jsx(Alert, {
    type: "info",
    closeable: false,
    children: upgrade ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "fscConfigure.seatsCard.seatLimitBanner.text",
        options: {
          currentTierName,
          maxQuantity,
          upgradeTierName: FSC_TIER_NAMES[upgrade.tier]
        }
      }), ' ', upgrade.cta]
    }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "fscConfigure.seatsCard.seatLimitBanner.textNoUpgrade",
      options: {
        currentTierName,
        maxQuantity
      }
    })
  });
}